module.exports = __webpack_public_path__ + "static/media/eudes.ef720533.png";